var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfExpDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 0.89543 3.89543 0 5 0H15L18 3L21 6V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#FAFCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H21L15 0V6Z",
    fill: "#D7E3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11605 12.7249V10.9799H7.00092C7.63069 10.9799 7.9097 11.3066 7.9097 11.8567C7.9097 12.3897 7.63069 12.7249 7.00092 12.7249H6.11605ZM9.05764 11.8567C9.05764 10.8166 8.38801 10 7.04875 10H5V16H6.11605V13.6963H7.04875C8.48367 13.6963 9.05764 12.7679 9.05764 11.8567Z",
    fill: "#1C2531"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7951 10H9.85002V16H11.7951C13.5728 16 14.7287 14.8223 14.7287 13.0086C14.7287 11.1862 13.5728 10 11.7951 10ZM10.9661 14.9771V11.0143H11.7553C12.9271 11.0143 13.5888 11.7622 13.5888 13.0086C13.5888 14.255 12.9271 14.9771 11.7553 14.9771H10.9661Z",
    fill: "#1C2531"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5642 16H16.6802V13.4642H18.4579V12.51H16.6802V10.9713H19V10H15.5642V16Z",
    fill: "#1C2531"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfExpDefault);
export default __webpack_public_path__ + "static/media/PDF Exp Default.59372010d230292b079d72c5fb2690a0.svg";
export { ForwardRef as ReactComponent };